/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

window.$ = window.jQuery = require('jquery');

import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
import VueHtmlToPaper from 'vue-html-to-paper';

const options = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css',
  ]
}

Vue.use(VueHtmlToPaper, options);
Vue.use(Vuesax)


// axios
import axios from 'axios'
Vue.prototype.$http = axios

// axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded'
// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

// Theme Configurations
import '../themeConfig.js'


// Algolia - Instant Search
import InstantSearch from 'vue-instantsearch';
Vue.use(InstantSearch);


// Firebase
import   '@/firebase/firebaseConfig'



// Auth0 Plugin
import AuthPlugin from "./plugins/auth";
Vue.use(AuthPlugin);


// ACL
import acl from './acl/acl'


// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css';

// Tailwind
import '@/assets/css/volho.css';


// Vue Router
import router from './router'


// Vuex Store
import store from './store/store'


// i18n
import i18n from './i18n/i18n'


// Vuesax Admin Filters
import './filters/filters'


// Clipboard
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);


// Tour
import VueTour from 'vue-tour'
Vue.use(VueTour)
require('vue-tour/dist/vue-tour.css')


// VeeValidate
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);


// Google Maps
import * as VueGoogleMaps from 'vue2-google-maps'
Vue.use(VueGoogleMaps, {
    load: {
        // Add your API key here
        key: 'YOUR_KEY',
        libraries: 'places', // This is required if you use the Auto complete plug-in
    },
})


// Feather font icon
require('./assets/css/iconfont.css')

import interceptorsSetup from './interceptors.js'
interceptorsSetup();

Vue.config.productionTip = false

var _vue = new Vue({
    methods: {
      androidAction: function(params) {
        console.log('Function is called from Android side', params);
      }
    },
    // mixins: [mixin],
    router,
    store,
    i18n,
    acl,
    render: h => h(App)
}).$mount('#app')

// android call this method
function actionToWebview(params) {
  _vue.androidAction(params);
}

// webview call this method
function actionToAndroid(status, text) {
  console.log(`Sending action to Android [${status}]`);
  if(typeof Android != 'undefined') {
    Android.statusCallback(status, text);
  } else {
    console.error('No Android object found');
  }
}

Vue.prototype.$actionToAndroid = actionToAndroid;